document.addEventListener('DOMContentLoaded', function () {
  var STORAGE_KEY = 'popupBienvenueDismissedUntil';

  document.querySelectorAll('[data-popup-bienvenue]').forEach(function (popup) {
    var marker = popup.querySelector('[data-popup-bienvenue-marker]');
    var justSubmitted = marker && marker.dataset.submitted === 'true';
    var justSucceeded = marker && marker.dataset.success === 'true';
    var delay = parseInt(popup.dataset.delay || '5000', 10);
    var hideDays = parseInt(popup.dataset.hideDays || '14', 10);

    function onKeydown(event) {
      if (event.key === 'Escape') {
        close(true);
      }
    }

    function open() {
      popup.hidden = false;
      document.addEventListener('keydown', onKeydown);
      var emailInput = popup.querySelector('input[type="email"]');
      if (emailInput && !justSubmitted) {
        emailInput.focus();
      }
    }

    function close(persist) {
      popup.hidden = true;
      document.removeEventListener('keydown', onKeydown);
      if (persist) {
        try {
          localStorage.setItem(STORAGE_KEY, String(Date.now() + hideDays * 86400000));
        } catch (e) {}
      }
    }

    popup.querySelectorAll('[data-popup-bienvenue-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        close(true);
      });
    });

    var copyButton = popup.querySelector('[data-popup-bienvenue-copy]');
    if (copyButton) {
      copyButton.addEventListener('click', function () {
        var code = copyButton.getAttribute('data-code') || '';
        if (!navigator.clipboard) return;
        navigator.clipboard.writeText(code).then(function () {
          var original = copyButton.textContent;
          copyButton.textContent = 'Copié !';
          setTimeout(function () {
            copyButton.textContent = original;
          }, 2000);
        });
      });
    }

    if (justSubmitted) {
      open();
      if (justSucceeded) {
        try {
          localStorage.setItem(STORAGE_KEY, String(Date.now() + 365 * 86400000));
        } catch (e) {}
      }
      return;
    }

    var dismissedUntil = 0;
    try {
      dismissedUntil = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
    } catch (e) {}

    if (dismissedUntil > Date.now()) {
      return;
    }

    window.setTimeout(open, delay);
  });
});
